import axios from "axios";

export const API = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL,
	headers: { "app-auth-token": process.env.REACT_APP_APP_AUTH_TOKEN },
});

export const getAllEvents = () => API.get("events");
export const createEvent = (data: any) =>
	API.post("events", data, {
		headers: {
			"app-auth-token": process.env.REACT_APP_APP_AUTH_TOKEN,
			"Content-Type": "multipart/form-data",
		},
	});
export const updateEvent = (id: string, data: any) =>
	API.patch(`events/${id}`, data);
export const deleteEvent = (id: string) => API.delete(`events/${id}`);
export const exportEvent = (data: any) => API.post(`export`, data);
export const downloadImage = (imageUrl: string) =>
	API.get(`/events/download?url=${encodeURIComponent(imageUrl)}`, {
		responseType: "blob",
	});
